export default {
  state: {
    doctor: [],  // 科室
  },
  getters: {
    doctor: state => state.doctor
  },
  mutations: {
    setDoctor(state, doctor){  // 科室
      state.doctor = doctor;
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/doctor.js